import React from 'react';
import { Outlet } from 'react-router-dom';

// import utils
import { setBodyBackgroudColor } from 'js/utils/general';

// import containers
import SectionPageWrapper from 'js/containers/section/Section.page-wrapper';

// import components
import GenericMetadata from 'js/components/generic/Generic.metadata';
import TransitionPage from 'js/containers/transition/Transition.page';

const PageCard = () => {
  React.useEffect(() => {
    setBodyBackgroudColor('#F7EBB1');
  }, []);

  return (
    <TransitionPage>
      <GenericMetadata title="Card --- Sesame Workshop Outdoor Learning Hub Homepage" />
      <SectionPageWrapper className="page--card" bgColor={'#F7EBB1'}>
        <Outlet />
      </SectionPageWrapper>
    </TransitionPage>
  );
};

export default PageCard;
